import { PATHS } from '@utils/paths';

export type CaseSettingsRouteKind =
  | 'caseSettingsPage'
  | 'caseSettingsRootRedirect';

export type CaseSettingsRouteDef = {
  readonly path: string;
  readonly kind: CaseSettingsRouteKind;
};

export function buildCaseSettingsRouteDefinitions(
  isClaimscoreSettingsEnabled: boolean,
): readonly CaseSettingsRouteDef[] {
  if (isClaimscoreSettingsEnabled) {
    return [
      {
        path: PATHS.PRIVATE_BASE.caseSetup,
        kind: 'caseSettingsPage',
      },
    ];
  }

  return [
    {
      path: PATHS.PRIVATE_BASE.caseSetup,
      kind: 'caseSettingsRootRedirect',
    },
    {
      path: PATHS.PRIVATE_BASE.caseSettings,
      kind: 'caseSettingsRootRedirect',
    },
    {
      path: `${PATHS.PRIVATE_BASE.caseSettings}/*`,
      kind: 'caseSettingsPage',
    },
  ];
}
